<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="20" height="20" rx="2.5" stroke="#D9DEE1" stroke-dasharray="2 2"/>
</svg>
